import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { MACOS_CHECKLIST } from '../../utils/constants';
import { HardDrive, ShieldCheck, Lock, ArrowRight, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function MacOS() {
  return <Layout data-id="element-2026">
      <div className="container mx-auto px-4 py-12" data-id="element-2027">
        <div className="mb-12" data-id="element-2028">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-2029">
            <HardDrive className="h-3 w-3 mr-2" data-id="element-2030" />
            Device Library
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-2031">
            macOS Security Protocol
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-2032">
            Standar pengamanan Mac untuk penggunaan pribadi & profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2033">
          <div className="lg:col-span-2 space-y-12" data-id="element-2034">
            <section data-id="element-2035">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-2036">
                <ShieldCheck className="h-6 w-6 text-cyan-500 mr-3" data-id="element-2037" />
                Baseline Security (Wajib)
              </h2>
              <div className="space-y-4" data-id="element-2038">
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2039">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2040">
                    FileVault Encryption
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-2041">
                    Wajib aktif. Mengenkripsi seluruh disk agar data tidak bisa
                    dibaca jika Mac dicuri. System Settings {'>'} Privacy &
                    Security {'>'} FileVault.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2042">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2043">
                    Automatic Updates
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-2044">
                    Pastikan "Install Security Responses and system files"
                    aktif.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-2045">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-2046">Gatekeeper</h3>
                  <p className="text-slate-400 text-sm" data-id="element-2047">
                    Set "Allow apps downloaded from" ke "App Store and
                    identified developers". Jangan matikan ini.
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-2048">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-2049">
                <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-2050" />
                Advanced Protection
              </h2>
              <ul className="space-y-4 list-disc list-inside text-slate-300" data-id="element-2051">
                <li data-id="element-2052">
                  <strong className="text-slate-100" data-id="element-2053">
                    Standard User Account:
                  </strong>{' '}
                  Gunakan akun non-admin untuk aktivitas harian. Buat akun Admin
                  terpisah hanya untuk maintenance.
                </li>
                <li data-id="element-2054">
                  <strong className="text-slate-100" data-id="element-2055">Firewall:</strong> Aktifkan
                  Firewall di System Settings {'>'} Network.
                </li>
                <li data-id="element-2056">
                  <strong className="text-slate-100" data-id="element-2057">Privacy Audit:</strong> Cek
                  "Privacy & Security" secara berkala. Cabut akses Screen
                  Recording/Microphone dari aplikasi yang tidak perlu.
                </li>
              </ul>
            </section>

            <section className="border-t border-slate-800 pt-8" data-id="element-2058">
              <h2 className="text-xl font-bold text-slate-100 mb-4 text-red-400" data-id="element-2059">
                Common Mistakes
              </h2>
              <ul className="space-y-3 text-slate-400" data-id="element-2060">
                <li className="flex items-start" data-id="element-2061">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2062" />
                  <span data-id="element-2063">
                    Login menggunakan akun Admin untuk browsing dan kerja
                    sehari-hari.
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2064">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-2065" />
                  <span data-id="element-2066">
                    Mematikan Gatekeeper (via terminal) untuk menginstall
                    aplikasi bajakan.
                  </span>
                </li>
              </ul>
            </section>
          </div>

          <div className="space-y-6" data-id="element-2067">
            <Checklist id="macos-checklist" title="macOS Checklist" items={MACOS_CHECKLIST} data-id="element-2068" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-2069">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-2070">Next Steps</h3>
              <div className="space-y-3" data-id="element-2071">
                <Link to="/devices/linux" data-id="element-2072">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2073">
                    Linux Protocol
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2074" />
                  </Button>
                </Link>
                <Link to="/personal/identity" data-id="element-2075">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-2076">
                    Identity Security
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-2077" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}